import { z } from 'zod';
import { PlatformIdSchema, ProductStatusSchema, UniversalProductSchema } from './platform';

export const PRODUCTS_DEFAULT_LIMIT = 20;
export const PRODUCTS_MAX_LIMIT = 100;

/**
 * `GET /api/products?cursor=&limit=&platformId=&status=&query=`
 *
 * - `limit` is a string from the URL; coerced to int and clamped to [1, 100].
 * - `query` is a naive substring match on title (Phase 1.5: Algolia / Typesense).
 * - `cursor` is opaque; produced by the previous page's response.
 * - Workspace is implicit (derived from session).
 */
export const ProductsQuerySchema = z.object({
  cursor: z.string().min(1).max(2048).optional(),
  limit: z
    .string()
    .optional()
    .transform((v) => (v === undefined ? undefined : Number.parseInt(v, 10)))
    .pipe(z.number().int().min(1).max(PRODUCTS_MAX_LIMIT).optional()),
  platformId: PlatformIdSchema.optional(),
  status: ProductStatusSchema.optional(),
  query: z.string().min(1).max(500).optional(),
});

export type ProductsQuery = z.infer<typeof ProductsQuerySchema>;

/**
 * Response envelope for `GET /api/products` — mirrors the generic `Page<T>`
 * interface with `UniversalProduct` bound so the shape can be validated at
 * runtime against the wire response.
 */
export const ProductsPageSchema = z.object({
  items: z.array(UniversalProductSchema),
  cursor: z.string().nullable(),
  hasMore: z.boolean(),
});

export type ProductsPage = z.infer<typeof ProductsPageSchema>;
